import { useChainId } from "@gu-corp/gu-wallet-connector";
import { chains } from "../providers/wallet-connector/useClient";

export function useChain() {
  const chainId = useChainId();
  return chains.find((chain) => chain.id === chainId);
}
